// Imported first by src/index.js: the route has to be right before the router and authPreview read it.
import { followPreviewDeepLink } from './previewDeepLink';

if (process.env.REACT_APP_WOOSMAP_ENV === 'develop') {
    followPreviewDeepLink(window, process.env.REACT_APP_BASENAME);
}
